import React, {useEffect, useRef, useState} from 'react';
import {xyz} from "./canvasTypes";
import {cubeOutline, makeSplit3DPlane, squareAroundCenter} from "./drawFunctions";

// todo make the shapes that go into the canvas tsx files that read in the context
export default function Canvas( {grid}:{grid:xyz} ){
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const [centerPoint, setCenterPoint] = useState<xyz>([128,128,128])

    let prepairCanvas = (): CanvasRenderingContext2D | null=>{
        if(!!!canvasRef || !!!canvasRef.current){return null;}
        const ctx = canvasRef.current.getContext("2d");
        // ctx?.strokeRect(200, 200, 40, 50);
        // ctx?.stroke(makePlane([[10,20],[100,30],[110,100],[15,90]]))
        if(!!!ctx){return null;}
        // @ts-ignore // it is in the docs and works so
        ctx.reset()

        // over, down
        squareAroundCenter(ctx, [100, 75], "blue") // top left
        squareAroundCenter(ctx, [235, 75], "magenta") // top right
        squareAroundCenter(ctx, [335, 125], "red") // right mid
        squareAroundCenter(ctx, [335, 335], "yellow") // bottom right
        squareAroundCenter(ctx, [125, 335], "lime") // bottom mid
        squareAroundCenter(ctx, [85,235], "cyan") // left mid

        cubeOutline(ctx)

        return ctx

    }

    // todo make a focus cube around our area when using center grid
    let drawCube = (ctx:CanvasRenderingContext2D | null) => {
        if(!!!ctx){return;}

        // let spot:xyz = [150,160,170]
        // let spot:xyz = [128,128,128]
        // let spot:xyz = [0,0,0]
        // let spot:xyz = [255,255,255]

        // todo scrap this and create the 12 squares in draw order from bottom to top so they have proper z
        ctx.strokeStyle = "green"
        makeSplit3DPlane(ctx, centerPoint,"y")
        ctx.strokeStyle = "red"
        makeSplit3DPlane(ctx, centerPoint,"x")
        ctx.strokeStyle = "blue"
        makeSplit3DPlane(ctx, centerPoint,"z")
        ctx.strokeStyle = "black"
        squareAroundCenter(ctx, centerPoint, `rgb(${grid[0]},${grid[1]},${grid[2]})`)


    }

    useEffect(() => {
        if (canvasRef.current) {
            drawCube(prepairCanvas())
        }
    }, []);

    useEffect(() => {
        setCenterPoint(grid)
    }, [grid]);

    useEffect(()=>{
        drawCube(prepairCanvas())
    },[centerPoint])

    return (<div>
        <canvas
            ref={canvasRef}
            width="400"
            height="350"
            style={{ border: "2px solid black" }}
        />
    </div>);
}

